import React from "react";
import AgendaList from "./AgendaList";
import LinksList from "./LinksList";

const AgendaAndLinksIndex = () => {
  return (
    <div className="d-flex flex-xl-row flex-column ">
      <AgendaList />
      <LinksList />
    </div>
  );
};

export default AgendaAndLinksIndex;
